import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const wrapper = css`
  text-align: center;

  @media (min-width: ${dimensions.tablet}) {
    max-width: 40rem;
  }
`;

export const subTitle = css`
  margin-top: 1rem;

  @media (min-width: ${dimensions.tablet}) {
    padding: 0 4rem;
  }
`;
export const tile = css`
  text-align: center;
  display: flex;
  align-items: center;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    text-align: left;
  }
`;

export const columns = css`
  && {
    margin: 4rem 0 3.75rem 0;
  }
`;

export const buttonContainer = css`
  display: flex;
  justify-content: end;
`;

export const button = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    width: 100%;
  }
`;
